import { Row } from 'react-bootstrap'
import OwnSkeleton from './OwnSkeleton'

const IsotopeSkeleton = ({ children }) => {
    return (
        <div>
            <ul className="nav mb-3 justify-content-center align-items-center gap-4">
                {Array(4).fill(0).map((_, i) => (
                    <li key={i} className="nav-item">
                        <OwnSkeleton width={80} height={30} />
                    </li>
                ))}
            </ul>

            <Row>
                {children}
            </Row>
        </div>
    )
}

export default IsotopeSkeleton